// src/components/PopularCastings.js
import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Modal from './Modal';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const slides = [
  {
    id: 1,
    title: 'Creative Council',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    tag: 'Verified',
    popupContent: `
      <div class="studio-message">
        <h2>For Creative Directors</h2>
        <p>The collective for visionary leadership</p>
        <ul>
          <li>📈 Media Strategy & Consultancy</li>
          <li>🎨 Branding & Identity Development</li>
          <li>📣 Campaign Ideation</li>
          <li>🎯 Concept Development</li>
          <li>🎨 Art Direction</li>
          <li>🤝 Collaboration with Production</li>
          <li>🤝 Strategic Marketing & Partnerships</li>
        </ul>
        <div class="cta">
          <strong>Got the Skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  },
  {
    id: 2,
    title: 'Studio',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    tag: 'Premium',
    popupContent: `
      <div class="studio-message">
        <h2>Production Crew</h2>
        <ul>
          <li>🎙️ Audio/Sound Production</li>
          <li>🎬 Video Production</li>
          <li>📸 Photography</li>
          <li>🖌️ Graphic Design</li>
          <li>🌀 Motion Graphics</li>
          <li>🎞️ Animation (2D/3D)</li>
        </ul>
        <div class="cta">
          <strong>Got the Skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  },
  {
    id: 3,
    title: 'Creator Space',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    tag: 'Premium',
    popupContent: `
      <div class="studio-message">
        <h2>For Content Creators</h2>
        <p>Adding personality to brand strategy</p>
        <ul>
          <li>🎤 Influencers</li>
          <li>🎤 Radio/TV personalities</li>
          <li>📰 Public Relations (PR)</li>
          <li>💬 Online Communities</li>
          <li>📝 Script & Copywriters</li>
          <li>📖 Blogs & Articles</li>
        </ul>
        <div class="cta">
          <strong>Got the skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  },
  {
    id: 4,
    title: 'Digital Marketing',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    tag: 'Verified',
    popupContent: `
      <div class="studio-message">
        <h2>Digital Marketing</h2>
        <p>Driving online reach.</p>
        <ul>
          <li>📱 Social media management</li>
          <li>📣 Media Buying & Ad Placement</li>
          <li>📊 Campaign Strategy</li>
          <li>📈 SEO & Analytics</li>
          <li>📧 Email Marketing</li>
          <li>💡 Content Design & Copywriting</li>
        </ul>
        <div class="cta">
          <strong>Got the Skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  },
  {
    id: 5,
    title: 'Brand Ambassadors',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    tag: '',
    popupContent: `
      <div class="studio-message">
        <h2>Brand Ambassadors</h2>
        <p>Adding rapport and fanbase to your brand</p>
        <ul>
          <li>🎤 Public Relations Representation</li>
          <li>🎁 Events Representatives</li>
          <li>🎤 Spokespersons</li>
          <li>🎤 Celebrities</li>
          <li>🎙️ Musicians</li>
          <li>📸 Models</li>
          <li>🎬 Actors</li>
          <li>🎬 Actresses</li>
          <li>🏅 Athletes & Sports Icons</li>
        </ul>
        <div class="cta">
          <strong>Got the Skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  },
  {
    id: 6,
    title: 'Events Team',
    image: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3',
    tag: 'Premium',
    popupContent: `
      <div class="studio-message">
        <h2>Events Team</h2>
        <p>Connecting brands to the audience</p>
        <ul>
          <li>📍 Trade show handling</li>
          <li>🎉 Product launching</li>
          <li>🎨 Promotional staff</li>
          <li>🗣️ Event Hosts, and MCs</li>
          <li>📈 Event Planning & Management</li>
        </ul>
        <div class="cta">
          <strong>Got the Skills?</strong><br>
          <a href="https://forms.gle/p4fbDyZQvBiqK7cQ9" target="_blank" rel="noopener noreferrer">Apply to Join</a>
        </div>
      </div>
    `
  }
];

const PopularCastings = () => {
  const swiperRef = useRef(null);
  const containerRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalHtml, setModalHtml] = useState('');

  // Intersection Observer to pause/play autoplay
  useEffect(() => {
    if (!containerRef.current || !swiperRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio > 0.5) {
          swiperRef.current.autoplay.start();
        } else {
          swiperRef.current.autoplay.stop();
        }
      },
      { threshold: [0, 0.5, 1] }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const openPopup = (html) => {
    setModalHtml(html);
    setModalOpen(true);
  };

  return (
    <>
      <section className="popular-castings section no-vertical-padding container">
        <h2 className="title has-text-centered">Dedicated Teams</h2>
        <div className="busy-wrapper" ref={containerRef}>
          <Swiper
            onSwiper={(sw) => (swiperRef.current = sw)}
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView="auto"
            spaceBetween={32}
            speed={500}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            loop
            navigation
            pagination={{ clickable: true }}
            className="castings-slider"
          >
            {slides.map((s) => (
              <SwiperSlide key={s.id} style={{ width: '264px' }}>
                <div
                  className="casting-item-container"
                  onClick={() => openPopup(s.popupContent)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="casting-item">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="casting-item-image"
                      width="448"
                      height="672"
                    />
                    <div className="casting-item-inner">
                      {s.tag && (
                        <div
                          className="tag is-gold is-rounded"

                          style={{
                            display: "none",
                            position: 'absolute',
                            top: '3mm',
                            left: 'calc(100% - 22mm)'
                          }}
                        >
                          {s.tag}
                        </div>
                      )}
                      <div className="casting-title is-hidden-tablet-only is-hidden-desktop-only">
                        {s.title}
                      </div>
                    </div>
                  </div>
                  <div className="casting-title casting-outside-title is-hidden-mobile is-hidden-widescreen">
                    {s.title}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="has-text-centered">
          <a href="/" className="button grey is-shadowless is-rounded">
            <span>Discover more</span>
          </a>
        </div>
      </section>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title="">
        <div
          className="popup-content"
          dangerouslySetInnerHTML={{ __html: modalHtml }}
        />
      </Modal>
    </>
  );
};

export default PopularCastings;